export enum SwayyEmployeeRoles {
  ALL = "all",
  VIEW_DASHBOARD = "view_dashboard",
  VIEW_CATALOG = "view_catalog",
  EDIT_CATALOG = "edit_catalog",
  VIEW_ORDERS = "view_orders",
  EDIT_ORDERS = "edit_orders",
  VIEW_SHIPMENTS = "view_shipments",
  EDIT_SHIPMENTS = "edit_shipments",
  VIEW_INVOICES = "view_invoices",
  EDIT_INVOICES = "edit_invoices",
  VIEW_COUPONS = "view_coupons",
  EDIT_COUPONS = "edit_coupons",
  CREATE_COUPONS = "create_coupons",
  MANAGE_CARRIERS = "manage_carriers",
  MANAGE_PAYMENTS = "manage_payments",
  VIEW_LEADS = "view_leads",
  MANAGE_SMS = "manage_sms",
}
